module.exports = __webpack_public_path__ + "img/parent_login_pic.0317612f.png";